import type { AnalyticsEvent } from '~/types/analyticsEvents'
import { useAmplitudeTrackingService } from '~/composables/useAmplitudeTrackingService'
import { useBrazeTrackingService } from '~/composables/useBrazeTrackingService'

export const useAnalyticsTrackingService = () => {
  const amplitudeTrackingService = useAmplitudeTrackingService()
  const brazeTrackingService = useBrazeTrackingService()

  function trackEvent(args: AnalyticsEvent) {
    let amplitudeTracked = false
    let brazeTracked = false

    try {
      amplitudeTracked = amplitudeTrackingService.trackEvent(args)
    } catch (error) {
      console.error('Amplitude tracking error', error)
    }

    try {
      brazeTracked = brazeTrackingService.trackEvent(args)
    } catch (error) {
      console.error('Braze tracking error', error)
    }

    return amplitudeTracked && brazeTracked
  }

  return {
    trackEvent
  }
}
